import actionCreatorFactory from "../actionCreatorFactory";

const actionCreator = actionCreatorFactory();

export const updateProgress = actionCreator<{
    id: string;
    loaded: number;
    total: number;
}>("UPDATE_PROGRESS");
